import React, { useEffect, useState, useRef } from 'react';
import { Box, Card, Typography, Button, Container, Avatar } from '@mui/material';
import { Phone, Email, Business } from '@mui/icons-material';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { firestore as db } from "../firebase";
import jsPDF from 'jspdf';
import { format } from 'date-fns';
import { getAuth, onAuthStateChanged } from "firebase/auth";


const MembershipCard = () => {
  const [memberData, setMemberData] = useState(null);
  const [loading, setLoading] = useState(true);
  const cardRef = useRef(null);
  const auth = getAuth();


  

 useEffect(() => {
  const auth = getAuth();

  const unsubscribe = onAuthStateChanged(auth, async (user) => {
    console.log("MembershipCard: Auth state changed, user:", user);
    
    if (!user) {
      console.log("MembershipCard: No user authenticated");
      setLoading(false);
      return;
    }

    const userEmail = user.email;
    const currentTenantId = sessionStorage.getItem("tenantId");
    const userRole = sessionStorage.getItem("userRole");
    
    console.log("MembershipCard: User authenticated - Email:", userEmail);
    console.log("MembershipCard: Tenant ID from sessionStorage:", currentTenantId);
    console.log("MembershipCard: User role from sessionStorage:", userRole);
    console.log("MembershipCard: All sessionStorage data:", {
      tenantId: sessionStorage.getItem("tenantId"),
      tenantName: sessionStorage.getItem("tenantName"),
      userRole: sessionStorage.getItem("userRole"),
      userEmail: sessionStorage.getItem("userEmail")
    });

    try {
      const membersRef = collection(db, "MembershipMaster");
      console.log("MembershipCard: Fetching for email:", userEmail, "tenantId:", currentTenantId);

      // Also check approval status and tenant filter
      let q = query(
        membersRef,
        where("personalEmail", "==", userEmail)
      );
      
      // Add tenant filter if tenantId exists
      if (currentTenantId) {
        q = query(
          membersRef,
          where("personalEmail", "==", userEmail),
          where("tenantId", "==", currentTenantId)
        );
        console.log("MembershipCard: Using tenant-filtered query");
      } else {
        console.log("MembershipCard: Using non-tenant-filtered query");
      }

      const querySnapshot = await getDocs(q);
      console.log("MembershipCard: Found", querySnapshot.size, "documents");

     if (!querySnapshot.empty) {
      const memberDoc = querySnapshot.docs[0];
      const data = memberDoc.data();
      console.log("MembershipCard: Member data:", data.status, data.personalEmail, data.tenantId);

  // Case-insensitive check
    if (data.status?.toLowerCase() === "approved") {
      console.log("MembershipCard: Setting member data for approved member");
      setMemberData({
        id: memberDoc.id,
        ...data,
        startDate: data.membershipStartDate,
        endDate: data.membershipEndDate
      });
    } else {
      console.log("MembershipCard: Member not approved, status:", data.status);
    }
  } else {
    console.log("MembershipCard: No member found for this email");
    
    // Try without tenant filter as fallback
    if (currentTenantId) {
      console.log("MembershipCard: Trying fallback query without tenant filter");
      const fallbackQuery = query(membersRef, where("personalEmail", "==", userEmail));
      const fallbackSnapshot = await getDocs(fallbackQuery);
      console.log("MembershipCard: Fallback query found", fallbackSnapshot.size, "documents");
      
      if (!fallbackSnapshot.empty) {
        const memberDoc = fallbackSnapshot.docs[0];
        const data = memberDoc.data();
        console.log("MembershipCard: Fallback member data:", data.status, data.personalEmail, data.tenantId);
        
        if (data.status?.toLowerCase() === "approved") {
          console.log("MembershipCard: Setting member data from fallback query");
          setMemberData({
            id: memberDoc.id,
            ...data,
            startDate: data.membershipStartDate,
            endDate: data.membershipEndDate
          });
        }
      }
    }
  }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching member data:", error);
      setLoading(false);
    }
  });

  return () => unsubscribe();
}, []);


  const downloadAsPDF = () => {
    if (!memberData) return;
    const pdf = new jsPDF('l', 'mm', [85, 54]);
    pdf.setFillColor(65, 105, 225);
    pdf.rect(0, 0, 85, 54, 'F');
    pdf.setTextColor(255, 255, 255);
    const memberSince = format(new Date(memberData.startDate), 'MMM yyyy');
    pdf.setFontSize(10);
    pdf.text(`Member Since: ${memberSince}`, 10, 10);
    pdf.setFontSize(18);
    pdf.setFont(undefined, 'bold');
    pdf.text(`${memberData.firstName} ${memberData.surname}`, 10, 18);
    pdf.setFont(undefined, 'normal');
    pdf.setFontSize(10);
    pdf.text(`ID: ${memberData.id.slice(0, 8)}`, 10, 25);
    const bulletY = [31, 37, 43];
    for (let i = 0; i < 3; i++) {
      pdf.circle(11, bulletY[i], 0.8, 'F');
    }
    pdf.text(memberData.mobileNo, 15, bulletY[0]);
    pdf.text(memberData.personalEmail, 15, bulletY[1]);
    pdf.text(memberData.organisation || "OmneVu", 15, bulletY[2]);
    pdf.setFontSize(16);
    pdf.setFont(undefined, 'bold');
    pdf.text("OV", 65, 38);
    pdf.setFontSize(10);
    pdf.text("Aalay", 52, 43);
    pdf.save('membership-card.pdf');
  };

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  if (!memberData) {
    return (
      <Container maxWidth="sm" sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>No membership data found.</Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Your email address: {auth.currentUser?.email}

        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Please check if you have an approved membership. If you've recently applied, your membership may still be pending approval.
        </Typography>
        <Typography variant="body2">
          If you believe this is an error, please contact support with the email you used for your membership application.
        </Typography>
        
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <Card
          ref={cardRef}
          sx={{
            width: '100%',
            maxWidth: 380,
            height: 240,
            background: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
            color: 'white',
            position: 'relative',
            overflow: 'hidden',
            borderRadius: 3,
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            p: 3,
            pr:5
          }}
        >
          <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 500 }}>
            Member Since: {format(new Date(memberData.startDate), 'MMM yyyy')}
          </Typography>
          <Typography  component="div" sx={{ mb: 0.5, fontWeight: 'bold', fontSize: 24, lineHeight: 1.2, wordBreak: 'break-word'}}>
            {memberData.firstName} {memberData.surname}
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
            ID: {memberData.id.slice(0, 8)}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Phone sx={{ color: 'white', mr: 1 }} />
            <Typography variant="body1">
              {memberData.mobileNo}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Email sx={{ color: 'white', mr: 1 }} />
            <Typography variant="body1" sx={{ 
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '220px'
            }}>
              {memberData.personalEmail}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Business sx={{ color: 'white', mr: 1 }} />
            <Typography variant="body1">
              {memberData.organisation || "OmneVu"}
            </Typography>
          </Box>
          <Avatar 
            src={memberData.photoURL || ""}
            sx={{ 
              width: 80, 
              height: 80, 
              border: '2px solid white',
              position: 'absolute',
              top: 20,
              right: 20,
              zIndex: 2,
              bgcolor: memberData.photoURL ? 'transparent' : 'grey.300'
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 15,
              right: 20,
              textAlign: 'center'
            }}
          >
            <Typography  sx={{ fontWeight: 'bold', letterSpacing: 1, lineHeight: 1 }}>
              OV
            </Typography>
            <Typography sx={{ letterSpacing: 2 }}>
              Aalay
            </Typography>
          </Box>
        </Card>
        <Button 
          variant="contained" 
          onClick={downloadAsPDF}
          sx={{ 
            bgcolor: '#4169E1',
            px: 6,
            py: 1.5,
            borderRadius: 25,
            textTransform: 'uppercase',
            fontWeight: 'bold',
            fontSize: 16,
            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            width: 'auto'
          }}
        >
          DOWNLOAD AS PDF
        </Button>
      </Box>
    </Container>
  );
};

export default MembershipCard; 